import React from 'react'

import { reverse } from 'named-urls'
import moment from 'moment'

import { Typography } from '@material-ui/core'

import { routes } from 'routes'
import { DotStatus, Link } from 'components'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'
import helpers from 'helpers'
import usePermissions from 'hooks/usePermissions'

const TableRowServiceTaxInvoice = ({ serviceTaxInvoice, ...rest }) => (
  <TableRow {...rest}>
    <TableCell>
      <div>
        <Typography component="span" variant="body2">
          Nota Fiscal:
        </Typography>{' '}
        {serviceTaxInvoice.id}
      </div>
      <div>
        <Typography component="span" variant="body2">
          Fatura:
        </Typography>{' '}
        <Link
          to={reverse(routes.invoices.show, {
            invoiceId: serviceTaxInvoice.invoiceToken,
          })}
          noPropagate
        >
          {serviceTaxInvoice.invoiceId}
        </Link>
      </div>
    </TableCell>
    <TableCell>
      {serviceTaxInvoice.nfId && parseInt(serviceTaxInvoice.nfId) !== 0 ? (
        serviceTaxInvoice.nfId
      ) : (
        <Typography variant="body2">Não emitida</Typography>
      )}
    </TableCell>
    <TableCell>
      <div>
        <Typography component="span" variant="body2">
          Identificador:
        </Typography>{' '}
        {serviceTaxInvoice.customer.id}
      </div>
      <div>
        <Typography component="span" variant="body2">
          Nome:
        </Typography>{' '}
        {serviceTaxInvoice.customer.name}
      </div>
      <div>
        <Typography component="span" variant="body2">
          Email:
        </Typography>{' '}
        {serviceTaxInvoice.customer.email}
      </div>
    </TableCell>
    <TableCell>
      {serviceTaxInvoice.issuedAt ? (
        moment(serviceTaxInvoice.issuedAt)
          .utc(false)
          .format('DD/MM/YYYY')
      ) : (
        <Typography variant="body2">Não emitida</Typography>
      )}
    </TableCell>
    <TableCell align="right">
      {helpers.currency(serviceTaxInvoice.amount)}
    </TableCell>
    <TableCell align="center">
      <DotStatus
        statusName={helpers.taxInvoices.status(serviceTaxInvoice.status)}
        statusTag={serviceTaxInvoice.status}
      />
    </TableCell>
  </TableRow>
)

const TaxInvoicesTable = ({ serviceTaxInvoices, isLoading }) => {
  const permissions = usePermissions()
  const permittedShowTaxInvoice = permissions.permitted(
    'show_service_tax_invoice',
  )

  return (
    <Table
      size="medium"
      emptyMessage="Nenhuma nota fiscal encontrada"
      isLoading={isLoading}
      noWrap
    >
      <TableHead>
        <TableRow>
          <TableCell>Identificador</TableCell>
          <TableCell>Número da nota</TableCell>
          <TableCell>Cliente</TableCell>
          <TableCell>Data emissão</TableCell>
          <TableCell align="right">Valor Total</TableCell>
          <TableCell align="center">Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {serviceTaxInvoices &&
          serviceTaxInvoices.map(serviceTaxInvoice => (
            <TableRowServiceTaxInvoice
              serviceTaxInvoice={serviceTaxInvoice}
              key={serviceTaxInvoice.id}
              pointer={permittedShowTaxInvoice}
              to={
                permittedShowTaxInvoice &&
                reverse(routes.taxInvoices.show, {
                  taxInvoiceId: serviceTaxInvoice.id,
                })
              }
              hover
            />
          ))}
      </TableBody>
    </Table>
  )
}

export default TaxInvoicesTable
